function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "satellite-svgrepo-com-(3)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(167.000000, 296.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1028_"
}, /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_1030_",
  fill: "#06384A",
  transform: "translate(237.729536, 203.373546) rotate(135.000000) translate(-237.729536, -203.373546) ",
  x: 227.729632,
  y: 160.874453,
  width: 19.9998082,
  height: 84.9981849
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_1031_",
  fill: "#084B63",
  transform: "translate(177.625906, 143.270553) rotate(135.000000) translate(-177.625906, -143.270553) ",
  x: 167.626002,
  y: 100.77146,
  width: 19.9998082,
  height: 84.9981849
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_67_",
  fill: "#419EBE",
  points: "55.65 42.508 34.437 63.721 78.631 107.915 96.308 104.379 99.844 86.702 79.515 52.23"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_66_",
  fill: "#419EBE",
  points: "98.076 0.081 76.863 21.294 86.586 45.159 121.057 65.489 138.735 61.953 142.27 44.275"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_65_",
  fill: "#82C8DB",
  points: "76.863 21.294 55.65 42.508 99.844 86.702 117.522 83.166 121.057 65.489"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_64_",
  fill: "#146A8A",
  points: "144.038 130.896 127.244 99.96 99.844 86.702 78.631 107.915 122.825 152.109"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_63_",
  fill: "#146A8A",
  points: "186.464 88.47 142.27 44.275 121.057 65.489 134.315 92.889 165.251 109.683"
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_62_",
  fill: "#419EBE",
  transform: "translate(132.548112, 98.192814) rotate(-135.000000) translate(-132.548112, -98.192814) ",
  x: 101.298911,
  y: 83.1929576,
  width: 62.4984006,
  height: 29.9997123
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_61_",
  fill: "#146A8A",
  points: "250.104 236.962 228.891 258.175 273.085 302.369 290.763 298.834 294.298 281.156 281.04 253.756"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_60_",
  fill: "#146A8A",
  points: "292.53 194.536 271.317 215.749 288.111 246.685 315.511 259.943 333.189 256.407 336.725 238.73"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_59_",
  fill: "#2089B0",
  points: "271.317 215.749 250.104 236.962 294.298 281.156 311.976 277.621 315.511 259.943"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_58_",
  fill: "#06384A",
  points: "338.492 325.35 328.77 301.485 294.298 281.156 273.085 302.369 317.279 346.564"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_57_",
  fill: "#06384A",
  points: "380.919 282.924 336.725 238.73 315.511 259.943 335.841 294.414 359.706 304.137"
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_56_",
  fill: "#146A8A",
  transform: "translate(327.001698, 292.647181) rotate(-135.000000) translate(-327.001698, -292.647181) ",
  x: 295.752497,
  y: 277.647325,
  width: 62.4984006,
  height: 29.9997123
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_55_",
  fill: "#06384A",
  transform: "translate(145.452021, 235.547597) rotate(135.000000) translate(-145.452021, -235.547597) ",
  x: 122.452242,
  y: 220.547741,
  width: 45.9995589,
  height: 29.9997123
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_54_",
  fill: "#06384A",
  points: "342.028 60.185 320.815 38.972 292.53 38.972 310.208 70.792 342.028 88.47"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_53_",
  fill: "#62B3CD",
  points: "292.53 38.972 257.175 74.327 281.924 99.076 313.744 81.398 317.279 63.721"
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_52_",
  fill: "#2089B0",
  transform: "translate(311.975544, 93.772311) rotate(-135.000000) translate(-311.975544, -93.772311) ",
  x: 294.475712,
  y: 68.7725503,
  width: 34.9996643,
  height: 49.9995205
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_51_",
  fill: "#82C8DB",
  points: "250.104 53.114 122.825 180.393 161.716 219.284 225.355 169.787 288.995 92.005"
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_50_",
  fill: "#419EBE",
  transform: "translate(244.801184, 175.090149) rotate(-135.000000) translate(-244.801184, -175.090149) ",
  x: 217.301948,
  y: 85.0920118,
  width: 54.9984726,
  height: 179.996274
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_49_",
  fill: "#06384A",
  transform: "translate(58.677449, 321.306720) rotate(135.000000) translate(-58.677449, -321.306720) ",
  x: 43.677593,
  y: 311.306816,
  width: 29.9997123,
  height: 19.9998082
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_48_",
  fill: "#146A8A",
  points: "71.468 298.743 88.445 266.523 70.751 257.2 46.902 302.46 62.721 318.279 76.863 318.279 76.863 304.137"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_47_",
  fill: "#06384A",
  points: "123.8 310.249 114.477 292.555 82.257 309.532 76.863 304.137 62.721 318.279 78.54 334.098"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.69,196.462 L92.614,288.386 L126.202,268.941 L145.647,235.353 C106.366,196.072 50.742,183.109 0.69,196.462 Z",
  id: "XMLID_46_",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.647,235.353 L92.614,288.386 L184.538,380.31 C197.891,330.258 184.928,274.634 145.647,235.353 Z",
  id: "XMLID_45_",
  fill: "#A3DDE9"
}))));

var SvgSatellite4 = function SvgSatellite4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "381px",
    height: "381px",
    viewBox: "167 296 381 381",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSatellite4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/satellite4.021c26fd.svg";
export { ForwardRef as ReactComponent };